import configService from "../../services/config";
import { v4 } from 'uuid';
import {datadogRum} from "@datadog/browser-rum";

export const sampling = (visitorId, requestId) => {
  try {
    const env = typeof sunbitEnv === "undefined" ? "dev" : sunbitEnv; // eslint-disable-line no-undef
    let deviceId = localStorage.getItem('deviceId');

    const samplingConfig = configService.getItem("sampling");
    const mainData = {
      application: 'my-sunbit=',
      env: env,
      deviceId: deviceId,
      visitId: v4(),
    };
    const commonData = {
      fingerprintjs: {visitorId, requestId},
    };
    const action = 'my-sunbit app started';
    const body = { ...mainData, action, timestamp: new Date(), data: { ...commonData } };
    fetch(samplingConfig.endpoint, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(body),
    });
  } catch (e) {
    datadogRum.addUserAction('sampling fingerprint error', {
      event: {
        error: e,
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/sampling/Sampling.js